import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cpl-download',
  templateUrl: './cpl-download.component.html',
  styleUrl: './cpl-download.component.css'
})
export class CplDownloadComponent {
  @Input() taskTitle: string;
  @Input() taskDescription: string;
  @Input() taskState: string;
  @Input() linkurl: string;
  @Input() linktext: string;
  @Input() canEdit: boolean = true;
   @Output() downloadaction = new EventEmitter<string>();

  constructor() {
    // Initialization logic can go here
  }

  downloadAction() {
   //console.log('Download action triggered for link:', this.linkurl);
    this.downloadaction.emit();
  }
}
